export enum ELanguages {
  EN = 'en',
  CN = 'cn',
}